import { keyBy as _keyBy } from 'lodash';
import {
    MarketWithOdds,
    MarketsNode,
} from '@core/models/struct/MarketTree';
import { MarketTreeDto } from './dtos/MarketTreeDto';

export function mapMarketTrees(marketTreeDto: MarketTreeDto): MarketsNode[] {
    return marketTreeDto.map((marketNodeDto) => {
        const markets: MarketWithOdds[] = marketNodeDto.markets.map((market) => {
            const marketId = parseInt(market.marketId, 10);
            return {
                marketId,
                odds: market.outcomes.map((outcome) => ({
                    id: outcome,
                    isEligibleForSuperAdvantage: !!market.superAdvantageOutcomes?.includes(outcome),
                })),
            };
        });
        return {
            sportId: marketNodeDto.sportId,
            markets: _keyBy(markets, 'marketId'),
        };
    });
}
